import { IInventoryPage } from '../../inventory-page.interface';


export const STORE_UPLOAD_PAGE: IInventoryPage = {
	'route': '/store/upload',
	'title': 'Store Upload',
	'uiReference': [
		'MOST POPULAR',
		'/mo',
		'See available options',
		'Limited Free Version',
		'EVERYTHING',
		'In PRO Version'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/public/public-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/store/store-upload/store-upload.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/store/store-upload/store-upload.component.html'
	]
};
